<template>
  <div class="pageIntro">
    <div class="portfolioSelection">
      <h2>Jennifer Baldwin:</h2>
      <!-- <div class="options">
        <filter-tag-button v-for="option in folioOptions" :title="option"
          v-bind:class="[{ selected: option === selectedFolio }, 'button']" :key="option"
          @click.prevent="updateProjects(option)"></filter-tag-button>
      </div> -->
    </div>
    <div class="selectedOptions">

      <p>Filters:</p>
      <filter-tag-button v-for="tag in allTags.sort()" :title="tag" :key="tag"
        v-bind:class="[{ selected: option === selectedFolio }, 'filter']" @click.prevent="filterProjects(tag)"
        :id="tag"></filter-tag-button>
    </div>
    <div class="removeFilters" v-if="selectedTags.length > 0">
      <div class="remove" @click.prevent="clearFilters()"> Remove Selected Filters </div>
    </div>
  </div>
  <div class="projects">
    <div class="unfiltered" v-if="tagMatches.length === 0">
      <a v-for="project in projects" :key="project.link" class="projectBox" v-bind:href="project.link" target="_blank">
        <project-preview :selectedTags="selectedTags" :link="project.link" :imgFile="project.imgFile"
          :title="project.title" :synopsis="project.synopsis" :tags="project.tags.sort()"></project-preview>
      </a>
    </div>
    <div class="filtered">
      <a v-for="match in tagMatches" :key="match.link" class="projectBox" v-bind:href="match.link" target="_blank">
        <project-preview :selectedTags="selectedTags" :link="match.link" :imgFile="match.imgFile" :title="match.title"
          :synopsis="match.synopsis" :tags="match.tags.sort()"></project-preview>
      </a>
    </div>
    <div class="siteSpec">
      <p>This site:</p>
      <filter-tag-button v-for="tag in thisProject" :title="tag"
        v-bind:class="[{ selected: selectedTags.includes(tag) }, `tag`]" :key="tag"></filter-tag-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedFolio: "Developer",
      folioOptions: ["Developer", "Designer", "Photographer", "Other"],
      thisProject: ["CSS", "SCSS", "HTML", "JavaScript", "Vue"],
      allTags: ["CSS", "SCSS", "HTML", "jQuery", "JavaScript", "PHP", "Vue"],
      selectedTags: [],
      projects: [
        {
          title: "Keurig Spoof",
          synopsis:
            "For this final, I had to use Firebase's authentication and adding it to the project. The Final had to look like the Keurig site with an opperational shopping cart, log in and create an account page, and show at least 10 coffee machines.",
          imgFile: "keurig.jpg",
          link: "https://github.com/jbldwn/final/blob/main/README.md",
          tags: ["JavaScript", "CSS", "SCSS", "HTML", "jQuery"],
        },
        {
          title: "Pong{ish}",
          synopsis:
            "This was a midterm I had for an intro to JavaScript course. The goal was to create a ball and a paddle. I was having so much fun I made it more challenging by making the ball get faster, and the paddle get shorter.",
          imgFile: "pongish.jpg",
          link: "https://in-info-web4.informatics.iupui.edu/~jbldwn/pongish/Pongish/",
          tags: ["JavaScript", "CSS", "HTML"],
        },
        // {
        //     title: "Project Name",
        //     synopsis: "Brief project description",
        //     imgFile: "about.jpg",
        //     link: "a link to project git",
        //     tags:["JavaScript", "CSS", "SCSS", "HTML"]
        // },
        /* Tag testers */
      ],
      DeveloperData: [
        {
          title: "Keurig Spoof",
          synopsis:
            "For this final, I had to use Firebase's authentication and adding it to the project. The Final had to look like the Keurig site with an opperational shopping cart, log in and create an account page, and show at least 10 coffee machines.",
          imgFile: "keurig.jpg",
          link: "https://github.com/jbldwn/final/blob/main/README.md",
          tags: ["JavaScript", "CSS", "SCSS", "HTML", "jQuery"],
        },
        {
          title: "Pong{ish}",
          synopsis:
            "This was a midterm I had for an intro to JavaScript course. The goal was to create a ball and a paddle. I was having so much fun I made it more challenging by making the ball get faster, and the paddle get shorter.",
          imgFile: "pongish.jpg",
          link: "https://in-info-web4.informatics.iupui.edu/~jbldwn/pongish/Pongish/",
          tags: ["JavaScript", "CSS", "HTML"],
        },
        // {
        //     title: "Project Name",
        //     synopsis: "Brief project description",
        //     imgFile: "about.jpg",
        //     link: "a link to project git",
        //     tags:["JavaScript", "CSS", "SCSS", "HTML"]
        // },
        /* Tag testers */
      ],
      DesignerDesignData: [
        {
          title: "Keurig Spoof",
          synopsis:
            "For this final, I had to use Firebase's authentication and adding it to the project. The Final had to look like the Keurig site with an opperational shopping cart, log in and create an account page, and show at least 10 coffee machines.",
          imgFile: "keurig.jpg",
          link: "https://github.com/jbldwn/final/blob/main/README.md",
          tags: ["Figma", "Story Board", "Developed", "Independant"],
        },
        {
          title: "Pong{ish}",
          synopsis:
            "This was a midterm I had for an intro to JavaScript course. The goal was to create a ball and a paddle. I was having so much fun I made it more challenging by making the ball get faster, and the paddle get shorter.",
          imgFile: "pongish.jpg",
          link: "https://in-info-web4.informatics.iupui.edu/~jbldwn/pongish/Pongish/",
          tags: ["Adobe XD", "Photo Inspiration", "Team"],
        },
        // {
        //     title: "Project Name",
        //     synopsis: "Brief project description",
        //     imgFile: "about.jpg",
        //     link: "a link to project git",
        //     tags:["JavaScript", "CSS", "SCSS", "html"]
        // },
        /* Tag testers */
      ],
      PhotographerData: [
        {
          title: "Keurig Spoof",
          synopsis:
            "For this final, I had to use Firebase's authentication and adding it to the project. The Final had to look like the Keurig site with an opperational shopping cart, log in and create an account page, and show at least 10 coffee machines.",
          imgFile: "keurig.jpg",
          link: "https://github.com/jbldwn/final/blob/main/README.md",
          tags: ["Landscapes", "Vintage", "Salvage", "Rural", "Portraits"],
        },
        {
          title: "Pong{ish}",
          synopsis:
            "This was a midterm I had for an intro to JavaScript course. The goal was to create a ball and a paddle. I was having so much fun I made it more challenging by making the ball get faster, and the paddle get shorter.",
          imgFile: "pongish.jpg",
          link: "https://in-info-web4.informatics.iupui.edu/~jbldwn/pongish/Pongish/",
          tags: ["Cityscapes", "Architecture", "Street", "Portraits"],
        },
        // {
        //     title: "Project Name",
        //     synopsis: "Brief project description",
        //     imgFile: "about.jpg",
        //     link: "a link to project git",
        //     tags:["JavaScript", "CSS", "SCSS", "HTML"]
        // },
        /* Tag testers */
      ],
      OtherData: [
        {
          title: "Keurig Spoof",
          synopsis:
            "For this final, I had to use Firebase's authentication and adding it to the project. The Final had to look like the Keurig site with an opperational shopping cart, log in and create an account page, and show at least 10 coffee machines.",
          imgFile: "keurig.jpg",
          link: "https://github.com/jbldwn/final/blob/main/README.md",
          tags: ["Audio", "Podcast", "Scenery", "Podcast Style"],
        },
        {
          title: "Pong{ish}",
          synopsis:
            "This was a midterm I had for an intro to JavaScript course. The goal was to create a ball and a paddle. I was having so much fun I made it more challenging by making the ball get faster, and the paddle get shorter.",
          imgFile: "pongish.jpg",
          link: "https://in-info-web4.informatics.iupui.edu/~jbldwn/pongish/Pongish/",
          tags: ["Video", "Sound Matching", "Audio Editing"],
        },
        // {
        //     title: "Project Name",
        //     synopsis: "Brief project description",
        //     imgFile: "about.jpg",
        //     link: "a link to project git",
        //     tags:["JavaScript", "CSS", "SCSS", "HTML"]
        // },
        /* Tag testers */
      ],

      tagMatches: [],
    };
  },
  methods: {
    filterProjects(tagName) {
      // add 'selected' styling, and push to Array
      const selectedTag = document.getElementById(tagName);

      selectedTag.classList.add("selected");
      this.selectedTags.push(tagName);

      // filter by selected filters
      for (let i = 0; i < this.projects.length; i++) {
        const project = this.projects[i];
        const tags = project.tags.filter((tag) => tag === tagName);
        if (tags.length > 0) {
          if (this.tagMatches.filter((obj) => obj === project) == "") {
            this.tagMatches.push(project);
          }
        }
      }
    },
    clearFilters() {
      for (let i = 0; i < this.selectedTags.length; i++) {
        const tag = this.selectedTags[i];
        const el = document.getElementById(tag);
        el.classList.remove("selected");
      }

      this.selectedTags = [];
      this.tagMatches = [];
    },

    updateTags() {
      let compiledTags = [];
      this.projects.forEach(project => {
        project.tags.forEach(tag => {
          if (!compiledTags.includes(tag)) {
            compiledTags.push(tag);
          }
        });
      });
      if (this.selectedFolio == 'Developer') {
        this.thisProject.forEach(tag => {
          if (!compiledTags.includes(tag)) {
            compiledTags.push(tag);
          }
        })
      }


      this.allTags = compiledTags;
      this.clearFilters();

    },
    updateProjects(folio) {
      this.selectedFolio = folio;

      if (folio === "Developer") {
        this.projects = this.DeveloperData;
      } else if (folio === "Designer") {
        this.projects = this.DesignerDesignData;
      } else if (folio === "Photographer") {
        this.projects = this.PhotographerData;
      } else if (folio === "Other") {
        this.projects = this.OtherData;
      }

      // this.selectedFolio = folio;

      //update filters
      this.updateTags();
    }
  },
};
</script>
<style scoped>
.pageIntro {
  margin-bottom: 15px;
  width: 100%;
}

.pageIntro h3 {
  margin-bottom: 0;
}

.pageIntro .portfolioSelection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  text-wrap: nowrap;
}

.pageIntro .portfolioSelection h2 {
  font-size: 2.8vw;
  margin-bottom: 0;
}

.pageIntro .portfolioSelection .options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 60%;
}

.pageIntro .portfolioSelection .options .button {
  font-size: 25px;
}

.pageIntro .selectedOptions {
  /* org and spacing */
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: end;
  flex-wrap: wrap;
  /* fonts */
  font-family: "typeBld";
  font-size: 22px;
  gap: 10px;
}

.pageIntro .selectedOptions p {
  margin-right: 5%;
  margin-bottom: 0;
  filter: drop-shadow(1px 2px 5px rgb(240, 240, 255));
}

.pageIntro .selectedOptions .filter {
  font-size: 20px;
  /* margin-left: 2%; */
}

.pageIntro .removeFilters {
  /* org and spacing */
  display: flex;
  justify-content: end;
  margin-top: 10px;
  /* font */
  font-size: 20px;
}

.pageIntro .removeFilters .remove {
  padding: 2px 10px 5px;
  /* style and font */
  border-radius: 5px;
  border: 3px solid #000;
  background-color: rgba(240, 240, 255, 0.15);
  cursor: pointer;
  font-family: typeBld;
}

.pageIntro .removeFilters .remove:hover {
  background-color: rgba(240, 240, 255, 0.4);
}

a.projectBox {
  text-decoration: none;
  color: inherit;
}

/* Site Spects */
.siteSpec {
  /* organization */
  display: flex;
  align-items: center;
  justify-content: end;
  flex-wrap: nowrap;
  margin-top: 15px;
  /* font */
  font-family: typeBld;
  font-size: 25px;
}

.siteSpec p {
  margin: 0px;
  filter: drop-shadow(1px 2px 5px rgb(240, 240, 255));
}

.siteSpec .tag {
  font-size: 14px;
  margin-left: 10px;
}

/* Small Screen Desktop */
@media only screen and (max-width: 1600px) {
  .pageIntro .portfolioSelection {
    flex-direction: column;
    align-items: start;
  }

  .pageIntro .portfolioSelection h2 {
    font-size: 4vw;
  }

  .pageIntro .portfolioSelection .options {
    width: 95%;
    margin: 5px auto 10px;
    display: flex;
    align-items: center;
    justify-content: start;
  }

  .pageIntro .portfolioSelection .options .button {
    font-size: 2vw;
    margin-top: 5px;
    margin-right: 2%;
  }

  .pageIntro .selectedOptions {
    font-size: 16px;
  }

  .pageIntro .selectedOptions .filter {
    font-size: 1.3vw;
    margin-top: 5px;
  }

  .pageIntro .removeFilters {
    font-size: 1.3vw;
  }

  .siteSpec {
    font-size: 2vw;
  }
}

/* Tablet */
@media only screen and (max-width: 915px) {
  .pageIntro {
    display: flex;
    flex-direction: column;
  }

  .pageIntro .portfolioSelection h2 {
    font-size: 6vw;
  }

  .pageIntro .portfolioSelection .options .button {
    font-size: 2.7vw;
  }

  .pageIntro .selectedOptions {
    align-self: flex-end;
    width: 75%;
  }

  .pageIntro .selectedOptions .filter {
    font-size: 1.9vw;
  }

  .pageIntro .removeFilters {
    font-size: 2vw;
  }

  .siteSpec {
    font-size: 2.7vw;
    flex-wrap: wrap;
    width: 75%;
    margin-left: auto;
    align-items: center;
    margin-top: 8px;
  }

  .siteSpec .tag,
  .siteSpec p {
    margin-bottom: 8px;
  }
}

/* Mobile */
@media only screen and (max-width: 560px) {
  .pageIntro .portfolioSelection h2 {
    font-size: 7vw;
  }

  .pageIntro .selectedOptions {
    width: 95%;
  }

  .pageIntro .selectedOptions .filter {
    font-size: 3vw;
  }

  .pageIntro .removeFilters {
    font-size: 3vw;
  }

  .siteSpec {
    font-size: 3vw;
    width: 80%;
  }
}
</style>
